import React, { Component } from 'react';
import { connect } from '@iris-platform/incontext';
import ApolloErrorActions from './ApolloErrorActions';

class ApolloErrorNotifier extends Component {
  componentDidMount() {
    this.unsubscribe = this.props.apolloErrorEmitter.subscribe((apolloError) => {
      this.props.showApolloError(apolloError);
    });
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    return React.Children.only(this.props.children);
  }
}

const mapStateToProps = state => ({
  apolloError: state.apolloError,
});

const mapDispatchToProps = dispatch => ({
  showApolloError: (apolloError) => {
    dispatch(ApolloErrorActions.showApolloError(apolloError));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ApolloErrorNotifier);
